export default __webpack_public_path__ + "static/Roboto-BoldItalic-d17b86957cee6a280e7aacee64e7e932.ttf";